import { z } from 'zod';
import { createLocalStorageApi } from 'v5/platform/ts/localStorageApi';
import { createUserPreferencesService } from './UserPreferencesService.impl';
import {
  DEFAULT_SHORTLIST_BOARD_VIEW,
  type ShortlistBoardPreferenceApis,
  type ShortlistBoardViewPreference
} from './UserPreferencesService';

export const createShortlistBoardPreferenceApis =
  (): ShortlistBoardPreferenceApis => ({
    shortlistBoardView: createLocalStorageApi<ShortlistBoardViewPreference>(
      'shortlist-board-view',
      (value): ShortlistBoardViewPreference =>
        z
          .object({ layout: z.enum(['GRID', 'LIST']) })
          .catch(DEFAULT_SHORTLIST_BOARD_VIEW)
          .parse(value),
      DEFAULT_SHORTLIST_BOARD_VIEW
    ),
    resourcePickerMaximized: createLocalStorageApi(
      'resource-picker-maximized',
      value => z.boolean().catch(false).parse(value),
      false
    ),
    resourcePickerWidth: createLocalStorageApi(
      'resource-picker-width',
      value => z.number().nullable().catch(null).parse(value),
      null
    )
  });

export const userPreferencesService = createUserPreferencesService(
  createShortlistBoardPreferenceApis()
);
